import { createStore } from "vuex";

export default createStore({
  state: {
    navIndex: localStorage.getItem("navIndex") || 0,
  },
  getters: {},
  mutations: {
    setNavIndex(state, index) {
      state.navIndex = index;
      localStorage.setItem("navIndex", index);
    },
  },
  actions: {},
  modules: {},
});
